/* eslint-disable no-restricted-imports */
import React, { FC } from 'react';
import { Box, Grid } from '@mui/material';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { DpContainer } from '@/components/blocks/DpContainer';
import { ItemWrap, ItemWrapBreadcrumb } from '@/components/layouts/ItemWrap';
import { useQueryMetaSelector } from 'integration/hooks/useQueryMetaSelector';
import { PLPProviderContext } from './PLPProvider';
import { ShowByCondition } from '../blocks/ShowByCondition';

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions

const PLPProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
	<PLPProviderContext>{children}</PLPProviderContext>
);

export const AsideExtended: FC<{ layout: Layout }> = ({ layout }) => {
	const pageGroup = useQueryMetaSelector('pageGroup');
	const pageIdentifier = useQueryMetaSelector('pageIdentifier');

	if (!layout) {
		return null;
	}

	const isPLP = pageGroup === 'ProductListPage';
	const isSearch = pageIdentifier === 'search';

	return (
		<PLPProvider>
			<LayoutSlot slot={layout.slots.header} />
			<Box component="main" sx={layoutMainSX(layout.slots.first?.length || 0)}>
				<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrapBreadcrumb} />

				<LayoutSlot slot={layout.slots.second} />

				<DpContainer
					isPLP={!!!layout.slots.pdp}
					withoutmargin
					component="section"
					framesx={{
						marginTop: { xs: '14px', sm: '0px' },
					}}
				>
					<Grid container columnSpacing="40px">
						<Grid
							item
							component="aside"
							xs={12}
							md={2}
							sx={{
								marginBottom: isPLP ? { xs: '13px', lg: '0px' } : undefined,
							}}
						>
							{layout.slots.aside ? (
								<Box sx={{ mt: { xs: '0px', md: '31px' } }}>
									<LayoutSlot slot={layout.slots.aside} />
								</Box>
							) : null}
						</Grid>
						<Grid item component="section" xs={12} md={10}>
							<LayoutSlot slot={layout.slots.third} />
						</Grid>
					</Grid>
					<ShowByCondition condition={layout.slots.third?.length === 0}>
						<Box sx={{ marginTop: { xs: '14px', sm: '15px' } }}>
							<LayoutSlot slot={layout.slots.fourth} />
						</Box>
					</ShowByCondition>
				</DpContainer>
				<ShowByCondition condition={isSearch}>
					<Box sx={{ marginTop: { xs: '14px', sm: '15px' } }}>
						<LayoutSlot slot={layout.slots.fourth} />
					</Box>
				</ShowByCondition>
				<LayoutSlot slot={layout.slots.fifth} ItemWrap={ItemWrap} />
				<LayoutSlot slot={layout.slots.footer} />
			</Box>
		</PLPProvider>
	);
};
